import { routes } from "~/routes";

export const headers = {
  [routes.intro]: {
    title: "Intro",
  },
  [routes.termsAndConditions]: {
    title: "Terms and Conditions",
    subtitle: "General Terms and Conditions",
  },
  [routes.faq]: {
    title: "F.A.Q.",
    subtitle: "We'll happily answer your questions!",
  },
  [routes.imprint]: {
    title: "Imprint",
    subtitle: "Our digital business card",
  },
  [routes.joinUs]: {
    title: "Join Us!",
    subtitle: "Intern or work as a ref. at LexMea",
  },
  [routes.privacyNotice]: {
    title: "Privacy Notice",
    subtitle: "GDPR and beyond!",
  },
  [routes.schemas]: {
    title: "Schemas",
    subtitle: "Overview of all LexMea schemas.",
  },
  [routes.team]: {
    title: "Team",
    subtitle: "Meet the LexMea-Team!",
  },
  [routes.updates]: {
    title: "Updates",
    subtitle: "What's new for you on LexMea",
  },
  [routes.vision]: {
    title: "Vision",
    subtitle: "Law in the Future",
  },
};
